"use client";
import { useState } from "react";

export function Label({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        fontSize: 12,
        fontWeight: 600,
        color: "var(--ink-2)",
        letterSpacing: 0.2,
        textTransform: "uppercase",
      }}
    >
      {children}
    </div>
  );
}

type FormFieldProps = {
  label: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  required?: boolean;
  textarea?: boolean;
  compact?: boolean;
  inputMode?: "text" | "numeric" | "decimal" | "tel" | "email";
  trailing?: React.ReactNode;
};

export function FormField({
  label,
  value,
  onChange,
  placeholder,
  required,
  textarea,
  compact,
  inputMode,
  trailing,
}: FormFieldProps) {
  const [focus, setFocus] = useState(false);
  return (
    <div>
      <Label>
        {label}
        {required && <span style={{ color: "#b91c1c", marginInlineStart: 4 }}>*</span>}
      </Label>
      <div
        style={{
          marginTop: 6,
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: textarea ? 12 : "0 14px",
          minHeight: textarea ? 76 : compact ? 40 : 46,
          background: "var(--surface-1)",
          border: `1px solid ${focus ? "var(--primary-600)" : "var(--border)"}`,
          borderRadius: 12,
          boxShadow: focus ? "0 0 0 3px var(--primary-50)" : "none",
          transition: "border-color 150ms, box-shadow 150ms",
        }}
      >
        {textarea ? (
          <textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            style={{
              flex: 1,
              border: 0,
              background: "transparent",
              outline: "none",
              resize: "vertical",
              fontSize: 14,
              color: "var(--ink-1)",
              fontFamily: "inherit",
              minHeight: 56,
            }}
          />
        ) : (
          <input
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            inputMode={inputMode}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            style={{
              flex: 1,
              border: 0,
              background: "transparent",
              outline: "none",
              fontSize: 14,
              color: "var(--ink-1)",
              fontFamily: "inherit",
              height: compact ? 38 : 44,
              minWidth: 0,
            }}
          />
        )}
        {trailing}
      </div>
    </div>
  );
}
